<template>
  <div class='setList'>
    <div class='list'>
       <div class='con flex-between' @click='gotoUrl("updatePwd")'><span>修改密码</span><svg-icon icon-class="right"/></div>
       
    </div>
    <div class="btnFixed">
        <div class="btn-reset" @click='goLogout' >退出登录</div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
      }
    },
    created(){
    },  
    methods: {
       goLogout(){
        this.$dialog.confirm({
                    message: '确定要退出登录吗?',
                    confirmButtonColor:'#0A59F7',
                    confirmButtonText:'确定',
                    cancelButtonColor:'#0A59F7',
                }).then(() => {
                    this.gotoUrl("routePage",{pageType: "DO_LOGOUT"});
                })
       }
    },
  }
</script>
<style lang="scss" >
.setList{
  font-size:.14rem;
  line-height: .48rem;
  color: rgba(0,0,0,.9);
  font-size: .17rem;
  padding:.12rem;
  .list{
      padding:0rem .12rem;
      background: #fff;
      text-align: center;
      border-radius: 8px;
    .con{
      display: flex;
      justify-content: space-between;
    }
  }
  
}

</style>